import { render } from "./PolicyHistoryTable.vue?vue&type=template&id=e30035b0"
import script from "./PolicyHistoryTable.vue?vue&type=script&lang=js"
export * from "./PolicyHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__